// Mock data for Two Sandwiches and a Nap website

export const crisisResources = [
  {
    id: 1,
    name: "988 Suicide & Crisis Lifeline",
    phone: "988",
    description: "24/7 free and confidential support for people in distress",
    available: "24/7"
  },
  {
    id: 2,
    name: "SAMHSA National Helpline",
    phone: "1-800-662-4357",
    description: "Treatment referral and information service for substance abuse",
    available: "24/7, 365 days"
  },
  {
    id: 3,
    name: "Crisis Text Line",
    phone: "Text HOME to 741741",
    description: "Free 24/7 support via text message",
    available: "24/7"
  }
];

export const supportGroups = [
  {
    id: 1,
    name: "Alcoholics Anonymous (AA)",
    website: "https://www.aa.org",
    description: "Find local AA meetings and support for alcohol addiction recovery",
    phone: "Check website for local meetings"
  },
  {
    id: 2,
    name: "Narcotics Anonymous (NA)",
    website: "https://www.na.org",
    description: "Find local NA meetings and support for drug addiction recovery",
    phone: "Check website for local meetings"
  },
  {
    id: 3,
    name: "Al-Anon Family Groups",
    website: "https://al-anon.org",
    description: "Support for families and friends of alcoholics",
    phone: "1-888-425-2666"
  },
  {
    id: 4,
    name: "SMART Recovery",
    website: "https://www.smartrecovery.org",
    description: "Science-based addiction recovery support program",
    phone: "Check website for meetings"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Why Two Sandwiches and a Nap?",
    excerpt: "Sometimes the simplest acts of self-care are the most powerful. Here's the story behind the name.",
    date: "December 2024",
    author: "Two Sandwiches and a Nap"
  },
  {
    id: 2,
    title: "Taking It One Day at a Time",
    excerpt: "Recovery isn't about perfection. It's about progress, one day at a time.",
    date: "December 2024",
    author: "Two Sandwiches and a Nap"
  },
  {
    id: 3,
    title: "Finding Your Support System",
    excerpt: "You don't have to do this alone. Here's how to build a circle of support.",
    date: "November 2024",
    author: "Two Sandwiches and a Nap"
  }
];

export const bookInfo = {
  title: "Two Sandwiches and a Nap",
  subtitle: "A Journey of Recovery and Hope",
  description: "A personal story of struggle, recovery, and finding hope in the simplest things. This book offers honest insights into the journey of addiction recovery and the power of self-compassion.",
  status: "Coming Soon",
  coverImage: "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=600&q=80"
};

export const socialLinks = {
  facebook: "https://www.facebook.com/twosandwichesandanap",
  email: "twosandwichesandanap@hotmail.com",
  website: "http://twosandwichesandanap.com"
};
